import { render, staticRenderFns } from "./EmployeeChip.vue?vue&type=template&id=5da03897&"
import script from "./EmployeeChip.vue?vue&type=script&lang=js&"
export * from "./EmployeeChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports